export default __webpack_public_path__ + "static/media/18.20fb2442.jpg";